import { Injectable } from '@angular/core';
import { trace } from '@opentelemetry/api';
import loggerProvider from '../../../opentelemetry-bootstrap';

@Injectable({
  providedIn: 'root',
})
export class OpenTelemetryService {
  private readonly appName: string = 'webshop2-frontend';

  getTracer() {
    return trace.getTracer(this.appName);
  }

  logError(error: Error) {
    loggerProvider?.getLogger(this.appName).emit({
      severityText: 'ERROR',
      body: error.message,
      attributes: {
        'application.name': this.appName,
        'service.name': this.appName,
        module: 'example',
        status: 'started',
      },
    });

    const tracer = this.getTracer();
    const span = tracer.startSpan('error-log');

    span.setAttribute('error', true);
    span.setAttribute('error.message', error.message);
    span.setAttribute('error.stack', error.stack || '');
    span.setAttribute('service.name', this.appName);

    span.end();
  }
}
